<template>
  <div class="lnb">
    <div class="logo">
      <a href="javascript:;" @click.prevent="goMain">
        <transition name="fade">
          <intro-logo v-if="introVal === 'logo'" />
          <img v-else-if="transImg" src="@/assets/images/introLogo00.png" />
          <lottie v-else-if="routeName === 'works'" :options="worksLottieOpt" />
          <lottie v-else-if="routeName === 'works-orangelife'" :options="worksOrangeLifeOpt" />
          <lottie v-else-if="routeName === 'works-kdb'" :options="worksKdbOpt" />
          <lottie v-else-if="routeName === 'works-jejuY'" :options="worksWaterOpt" />
          <lottie v-else-if="routeName === 'works-tigerE'" :options="worksTigerETFOpt" />
          <lottie v-else-if="routeName === 'works-samsungL'" :options="workSamsunglifeOpt" />
          <lottie v-else-if="routeName === 'works-ioneB'" :options="worksIOneBankOpt" />
          <lottie v-else-if="routeName === 'works-kiwoom'" :options="worksKiwoomOpt" />
          <lottie v-else-if="routeName === 'works-TitleistA'" :options="worksTitleistOpt" />
          <lottie v-else-if="routeName === 'works-TitleistM'" :options="worksTitleistOpt" />
          <lottie v-else-if="routeName === 'works-samsungW'" :options="worksSswsOpt" />
          <lottie v-else-if="routeName === 'works-TrueEtn'" :options="worksSswsOpt" />
          <lottie v-else-if="routeName === 'works-KBstar'" :options="worksKBstarOpt" />
          <lottie v-else-if="routeName === 'works-samsungF'" :options="worksSsFireOpt" />
          <lottie v-else-if="routeName === 'works-kyobo'" :options="worksKyoboOpt" />
          <lottie v-else-if="routeName === 'works-maumAI'" :options="worksMaumAIOpt" />
          <lottie v-else-if="routeName === 'works-KiupIBK'" :options="worksKiupIBKOpt" />
          <lottie v-else-if="routeName === 'works-Krds'" :options="worksKrdsOpt" />
          <lottie v-else-if="startProjectPop || recruitPop || routeName === 'contact'" :options="contactLottieOpt" />
          <lottie v-else-if="awardsPop" :options="awardLottieOpt" />
          <lottie v-else-if="pdsPop" :options="pdsLogoOpt" />
          <img v-else-if="routeName === 'news'" src="@/assets/images/ico_logo_rainbow.png" />
          <img v-else-if="introVal === 'end'" src="@/assets/images/ico_logo_main.svg" />
        </transition>
      </a>
      <div
        v-show="!startProjectPop && !awardsPop && !recruitPop && !culturePop"
        class="hi"
        @click.prevent="goBack"
      >
        <p class="hi-mo" :class="readyAction ? 'ready-action' : ''">
          <span ref="lnbCopy" id="lnbCopy" />
          <span :class="copy === '' ? 'noshow' : ''" class="emoji">
            <img v-if="navigation" src="@/assets/images/lnb_video_game.png" alt="" />
            <img v-else-if="pdsPop" src="@/assets/images/lnb_palette.png" alt="" />
            <img v-else-if="routeName === 'contact'" src="@/assets/images/lnb_flag.png" alt="" />
            <img v-else-if="routeName === 'works'" src="@/assets/images/lnb_fire.png" alt="" />
            <img v-else-if="routeName === 'news'" src="@/assets/images/lnb_bookmark.png" alt="" />
            <span
              v-else-if="routePath.indexOf('news') > -1 || routePath.indexOf('works') > -1"
              class="ico-back"
              :class="routeThemes === 'white' ? 'white' : ''"
            />
            <img v-else src="@/assets/images/lnb_hand.png" alt="" />
          </span>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { gsap, TimelineLite, TextPlugin } from 'gsap/all';
import { mapState, mapActions } from 'vuex';
import common from '@/shared/mixin/common.js';
import Lottie from 'vue-lottie';
import introLogo from '@/components/IntroLogo.vue';
import awardLogo from '@/assets/json/motion/awardLogo.json';
import worksOrangeLife from '@/assets/json/motion/worksOrangeLife.json';
import worksSsws from '@/assets/json/motion/ssws.json';
import worksKdb from '@/assets/json/motion/worksKdb.json';
import worksWater from '@/assets/json/motion/worksWater.json';
import worksKiwoom from '@/assets/json/motion/kiwoom.json';
import worksTigerETF from '@/assets/json/motion/worksTigerETF.json';
import worksIOneBank from '@/assets/json/motion/worksIOneBank.json';
import worksLogo from '@/assets/json/motion/worksLogo.json';
import worksTitleist from '@/assets/json/motion/worksTitleist.json';
import contactLogo from '@/assets/json/motion/contactLogo.json';
import workSamsunglife from '@/assets/json/motion/workSamsunglife.json';
import worksKBstar from '@/assets/json/motion/KBstar.json';
import worksSsFire from '@/assets/json/motion/SamsungFire.json';
import pdsLogo from '@/assets/json/motion/pdsLogo.json';
import worksKyobo from '@/assets/json/motion/kyobo.json';
import worksMaumAI from '@/assets/json/motion/maum.json';
import worksKiupIBK from '@/assets/json/motion/KiupIBK.json';
import worksKrds from '@/assets/json/motion/krds.json';
gsap.registerPlugin(TextPlugin);
export default {
  mixins: [common],
  name: 'LNB',
  components: {
    introLogo,
    Lottie
  },
  data() {
    return {
      worksSswsOpt: { animationData: worksSsws, loop: false, autoplay: true },
      awardLottieOpt: { animationData: awardLogo, loop: false, autoplay: true },
      worksLottieOpt: { animationData: worksLogo, loop: false, autoplay: true },
      contactLottieOpt: { animationData: contactLogo, loop: false, autoplay: true },
      worksOrangeLifeOpt: { animationData: worksOrangeLife, loop: false, autoplay: true },
      worksKdbOpt: { animationData: worksKdb, loop: false, autoplay: true },
      worksWaterOpt: { animationData: worksWater, loop: false, autoplay: true },
      worksTigerETFOpt: { animationData: worksTigerETF, loop: false, autoplay: true },
      worksIOneBankOpt: { animationData: worksIOneBank, loop: false, autoplay: true },
      workSamsunglifeOpt: { animationData: workSamsunglife, loop: false, autoplay: true },
      worksKiwoomOpt: { animationData: worksKiwoom, loop: false, autoplay: true },
      worksTitleistOpt: { animationData: worksTitleist, loop: false, autoplay: true },
      worksKBstarOpt: { animationData: worksKBstar, loop: false, autoplay: true },
      worksSsFireOpt: { animationData: worksSsFire, loop: false, autoplay: true },
      pdsLogoOpt: { animationData: pdsLogo, loop: false, autoplay: true },
      worksKyoboOpt: { animationData: worksKyobo, loop: false, autoplay: true },
      worksMaumAIOpt: { animationData: worksMaumAI, loop: false, autoplay: true },
      worksKiupIBKOpt: { animationData: worksKiupIBK, loop: false, autoplay: true },
      worksKrdsOpt: { animationData: worksKrds, loop: false, autoplay: true },
      dfCopy: 'Hi~ We are PULIP :P',
      copy: '',
      tl: '',
      anim: '',
      transImg: false
    };
  },
  computed: {
    ...mapState('common', {
      introVal: state => state.introVal,
      readyAction: state => state.readyAction,
      navigation: state => state.navigation,
      lnbCopy: state => state.lnbCopy,
      startProjectPop: state => state.startProjectPop,
      recruitPop: state => state.recruitPop,
      awardsPop: state => state.awardsPop,
      culturePop: state => state.culturePop,
      pdsPop: state => state.pdsPop,
      pdsLnb: state => state.pdsLnb
    }),
    routeName() {
      return this.$route.name;
    },
    routePath() {
      return this.$route.path;
    },
    routeThemes() {
      return this.$route.meta.themes;
    }
  },
  watch: {
    '$route.name'(to, from) {
      this.transImgEffect();
      this.changeCopy(this.getRouterCopy());
    },
    introVal: {
      handler(newValue) {
        console.log(newValue);
        if (newValue === 'logo') {
        }
      },
      deep: true
    },
    lnbCopy(newValue) {
      if (newValue) {
        this.changeCopy(newValue);
      }
    },
    navigation(newValue) {
      if (!newValue) {
        this.changeCopy(this.getRouterCopy());
      } else {
        this.changeCopy('Menu');
      }
    },
    startProjectPop(newValue) {
      if (!newValue) {
        this.changeCopy(this.getRouterCopy());
      } else {
        this.transImgEffect();
        this.changeCopy('1');
      }
    },
    awardsPop(newValue) {
      if (!newValue) {
        this.changeCopy(this.getRouterCopy());
      } else {
        this.transImgEffect();
        this.changeCopy('1');
      }
    },
    recruitPop(newValue) {
      if (!newValue) {
        this.changeCopy(this.getRouterCopy());
      } else {
        this.transImgEffect();
        this.changeCopy('1');
      }
    },
    pdsPop(newValue) {
      if (!newValue) {
        this.changeCopy(this.getRouterCopy());
      } else {
        this.transImgEffect();
        this.changeCopy('pds');
      }
    }
  },
  methods: {
    ...mapActions('common', {
      setLnbCopyAction: 'setLnbCopy',
      setIntroAction: 'setIntro'
    }),
    goBack() {
      const n = this.$route.path;
      if (n.indexOf('news') > -1) {
        this.$router.push({ name: 'news' });
      } else if (n.indexOf('works') > -1) {
        this.$router.push({ name: 'works' });
      }
      return false;
    },
    goMain() {
      this.hideAllPop();
      if (this.$route.name !== 'main') {
        this.$router.push({ name: 'main' });
      }
    },
    getRouterCopy() {
      const n = this.$route.name;
      const p = this.$route.path;
      if (n === 'main') {
        return this.dfCopy;
      } else if (n === 'works') {
        return 'Works';
      } else if (n === 'news') {
        return 'News';
      } else if (n === 'contact') {
        return 'Contact Us';
      } else if (p.indexOf('news') > -1 || p.indexOf('works') > -1) {
        return '2';
      } else {
        return this.dfCopy;
      }
    },
    changeCopy(s) {
      let c = '#000';
      this.copy = s;
      if (s === '0') {
        console.log(s);
        this.copy = this.dfCopy;
      } else if (s === '1') {
        c = '#fff';
        this.copy = '';
      } else if (s === '2') {
        if (this.$route.meta.themes === 'white' && !this.navigation) {
          c = '#fff';
        }
        this.copy = 'Back to List';
      } else if (s === 'pds') {
        c = '#fff';
        this.copy = 'Welcome to PDS';

        let popArea = document.querySelector('.popArea.active');
        let visualWrapper = document.querySelector('.visual');
        let lnbCopy = document.querySelector('#lnbCopy');

        popArea.scrollTop = 0;
        popArea.addEventListener('scroll', () => {
          //console.log('스크롤 감지됨');
          let visualH = visualWrapper.clientHeight;
          let scrollY = popArea.scrollTop;
          if (scrollY > visualH) {
            // console.log('ok');
            lnbCopy.style.color = '#000';
          } else {
            lnbCopy.style.color = c;
          }
        });


      }
      return this.tl.to(this.$refs.lnbCopy, 1, { css: { color: c }, text: { value: this.copy } });
    },
    handleAnimation: function (anim) {
      this.anim = anim;
      this.anim.setSpeed(1);
    },
    transImgEffect() {
      this.transImg = true;
      setTimeout(_ => {
        this.transImg = false;
      }, 50);
    }
  },
  mounted() {
    this.tl = new TimelineLite();
    this.changeCopy(this.getRouterCopy());
  }
};
</script>
